import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import FontSizeOutlinedSvg from "@ant-design/icons-svg/es/asn/FontSizeOutlined";
import AntdIcon from "../components/AntdIcon";
var FontSizeOutlined = function FontSizeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: FontSizeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  FontSizeOutlined.displayName = 'FontSizeOutlined';
}
export default /*#__PURE__*/React.forwardRef(FontSizeOutlined);